module.exports = __webpack_public_path__ + "static/media/auditlog.90c0e66f.svg";